import React, {useState} from 'react';
import {Button, Modal, Popconfirm, Space, Tooltip, message} from 'antd';
import {DeleteOutlined, DownloadOutlined, SettingOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import api from '../api';
import {handleApiError} from '../helpers/formatApiError';
import MetadataEntityImportSetup from './MetadataEntityImportSetup';

export default function MetadataEntityImportActions({metadataImport, onChanged}) {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);
    const canReprocess = metadataImport.aasm_state === 'processed' && metadataImport.ready_for_processing === true;

    const destroy = () => {
        api.delete(`/api/metadata_entity_imports/${metadataImport.id}`).then(() => {
            message.success(t("metadata-entity-import-canceled", "Import canceled."));
            onChanged && onChanged();
        }).catch(handleApiError);
    };

    return (
        <Space size={5}>
            {["analyzed", "processing", "processed", "errored"].includes(metadataImport.aasm_state) && (<>
                <Button size="small" icon={<SettingOutlined/>} onClick={() => setOpen(true)}>
                    {metadataImport.aasm_state === "analyzed" ? t("button-process", "Process") :
                        canReprocess ? t('results-and-reprocess', 'Results / Reprocess') : t("results", "Results")}...
                </Button>
                <Modal
                    title={t("process-custom-metadata-entity-import", "Process Custom Metadata Entity Import")}
                    open={open}
                    onCancel={() => setOpen(false)}
                    footer={null}
                    destroyOnClose
                >
                    <MetadataEntityImportSetup
                        metadataImport={metadataImport}
                        onDone={() => {
                            onChanged && onChanged();
                        }}
                    />
                </Modal>
            </>)}
            {metadataImport.download_url && (
                <Tooltip title={t("download-uploaded-file", "Download uploaded file")}>
                    <Button
                        size="small"
                        icon={<DownloadOutlined/>}
                        href={metadataImport.download_url}
                        download={metadataImport.filename}
                        target="_blank"
                        rel="noopener noreferrer"
                    />
                </Tooltip>
            )}
            {!["processing", "processed"].includes(metadataImport.aasm_state) && (
                <Popconfirm
                    title={t("confirm-cancel-import", "Cancel this import?")}
                    onConfirm={destroy}
                >
                    <Button size="small" danger icon={<DeleteOutlined/>}/>
                </Popconfirm>
            )}
        </Space>
    );
}
